import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { DefaultPageViewModel } from './default-page.viewmodel';
import {
    RESTRICT_ACCESS_ENABLED,
    RESTRICT_ACCESS_FILTERS
} from '../../../../../../../modules/passport-pages/config';
import './restrict-access-container.scss';
import {FiltersMultiSelectButton} from '../../../../../../global/multi-select/filters-multi-select-button';
import {AttendanceType, CustomFieldsOptionsListDTO, RestrictAccessFilter} from '../../../../../../../api/custom-pages.dao';
import {AccessFilter} from './access-filter-container';
import { CustomPageFormViewModel } from '../custom-pages/custom-page.viewmodel';
import { addText, cancelText } from '../../../../../../../constants/common-labels.constants';
export interface IRestrictAccessContainer {
    pageVm: DefaultPageViewModel | CustomPageFormViewModel;
    organizationTypes: string[];
    maxFiltersCount: number;
    customFieldsOptionsList: CustomFieldsOptionsListDTO[];
}

export const noneAsNullOrUndefined = '';

export const RestrictAccessContainer = mobxReact.observer(({
    pageVm,
    organizationTypes,
    maxFiltersCount,
    customFieldsOptionsList,
}: IRestrictAccessContainer) => {

    const {
        value: restrictedAccessFiltersValue,
        touched: restrictedAccessFiltersTouched
    } = pageVm.getFieldByKey(RESTRICT_ACCESS_FILTERS);


    const handlerDelete = (filterToDelete: RestrictAccessFilter) => {
        const newValue = (restrictedAccessFiltersValue as RestrictAccessFilter[]).filter(el => el !== filterToDelete);
        pageVm.setFieldValueByKey(RESTRICT_ACCESS_FILTERS, newValue);
    };

    const items = {
        allowedOrganizationTypes: [noneAsNullOrUndefined, ...organizationTypes],
        allowedAttendanceMethods: [AttendanceType.InPerson, AttendanceType.Virtual, AttendanceType.Both],
        allowedOptions: customFieldsOptionsList,
    };

    const onAddAccessFilter = (filter: RestrictAccessFilter) => {
        const {allowedOptions, ...restFilters} = filter;
        if (
            Object.values(restFilters).every(item => !item.length)
            && Object.values(allowedOptions).every(item => !item?.length)
        ) return;

        pageVm.setFieldValueByKey(RESTRICT_ACCESS_FILTERS, [...restrictedAccessFiltersValue as RestrictAccessFilter[], filter]);
        pageVm.setAccessFiltersValid(true);

        if (!restrictedAccessFiltersTouched) {
            pageVm.setValueTouched(RESTRICT_ACCESS_ENABLED);
        }
    };

    const filters = restrictedAccessFiltersValue as RestrictAccessFilter[] || [];

    return (
        <div className='list'>
            <div className='list__label-wrapper'>
                <div className='list__label'>
                    <FormattedMessage
                        id='oe.input.filters'
                        description='Input label'
                        defaultMessage='Filters'
                    />
                </div>
            </div>
            { filters.map((filter, index) => (
                <AccessFilter
                    customFieldsOptionsList={customFieldsOptionsList}
                    key={index}
                    name={'Filter ' + (index + 1)}
                    filter={filter}
                    onDelete={() => handlerDelete(filter)}
                />
            ))}
            { filters.length < maxFiltersCount && <FiltersMultiSelectButton
                className='default-button__add-button'
                items={items}
                text={
                    <FormattedMessage
                        id='oe.button.label.addFilter'
                        description='Button label'
                        defaultMessage='+ Add Filter'
                    />
                }
                applyButtonText={addText()}
                resetButtonText={cancelText()}
                onChange={onAddAccessFilter}
            />}
            {
                (!pageVm.accessFilters)
                    ? (
                        <span className='oe-form-field__error'>
                            <FormattedMessage
                                id='oe.validation.error.restrictFiltersErrorMessage'
                                defaultMessage='Please add at least one filter'
                            />
                        </span>
                        )
                    : null
            }
        </div>
    );
});


